import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatOption, MatSelect } from "@angular/material/select";
import { CampaignOfferGoalType } from "@playcharge/common/models/backend/offers/campaign-offer-goal-type";
import { EnumKeyValuePipe } from "../../../pipes/enumKeyValue.pipe";
import { MatButton } from "@angular/material/button";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-add-goal-dialog",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatSelect,
        MatOption,
        MatButton,
        EnumKeyValuePipe,
    ],
    templateUrl: "./add-goal-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddGoalDialogComponent {
    private _selfRef: MatDialogRef<AddGoalDialogComponent> = inject(
        MatDialogRef<AddGoalDialogComponent>,
    );

    public form: FormGroup<{ goalType: FormControl<CampaignOfferGoalType> }> = new FormGroup<{
        goalType: FormControl<CampaignOfferGoalType>;
    }>({
        goalType: new FormControl<CampaignOfferGoalType>(CampaignOfferGoalType.Event, {
            nonNullable: true,
        }),
    });

    public CampaignOfferGoalType: typeof CampaignOfferGoalType = CampaignOfferGoalType;

    public addGoal() {
        this._selfRef.close(this.form.getRawValue().goalType);
    }
}
